import React, {useEffect, useState} from 'react';
import {Modal} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {checkIsUpdateTrigger, editTriggerItem, modalVisibilityTrigger} from "../../redux-store/selectors";
import {createNewTrigger, fetchInstructions, hideModalTrigger, updateTrigger} from "../../redux-store/triggers";
import {Select} from "antd";
import {
    limitedToOptions,
    sunPositionOptions,
    triggerDayOfMonth,
    triggerTypeOptions,
    twilightTypeOptions
} from "../../constants/triggerOptions";
import api from "../../api/apiInterceptor";
import {setShowDeleteModal} from "../../redux-store/dynamicTable";

const {Option} = Select

const defaultValues = {
    "name": null,
    "type": null,
    "minutes": null,
    "time": null,
    "weekDays": null,
    "dayOfMonth": null,
    "limit": null,
    "margin": null,
    "sunPosition": null,
    "twilight": null,
    "offset": null,
    "methodName": null,
    "arguments": [],
    "exceptions": []
}

const TriggerModal = ({installationId, triggerItemId}) => {
    const {
        register,
        handleSubmit,
        formState: {isSubmitSuccessful},
        watch,
        reset,
        setValue,
        control
    } = useForm();
    const dispatch = useDispatch();
    const modalStatus = useSelector(modalVisibilityTrigger)
    const triggerTypeSelect = watch("type")
    const checkIsUpdateForm = useSelector(checkIsUpdateTrigger)
    const updateTriggerData = useSelector(editTriggerItem)

    const [commandProducersOptions, setCommandProducersOptions] = useState([])
    const [formValues, setFormValues] = useState([])

    const watchDate = watch("date")
    const watchRepeat = watch("repeat")

    useEffect(() => {
        assembleSelects();
    }, []);

    useEffect(() => {
        if (isSubmitSuccessful) {
            reset(defaultValues)
        }
    }, [isSubmitSuccessful])

    useEffect(() => {
        if (updateTriggerData !== undefined && Object.entries(updateTriggerData).length > 0) {
            setValue("weekDays", updateTriggerData.weekDays)
            setValue("type", updateTriggerData.type)
            setValue("twilight", updateTriggerData.twilight)
            setValue("time", updateTriggerData.time)
            setValue("sunPosition", updateTriggerData.sunPosition)
            setValue("offset", updateTriggerData.offset)
            setValue("name", updateTriggerData.name)
            setValue("minutes", updateTriggerData.minutes)
            setValue("margin", updateTriggerData.margin)
            setValue("limit", updateTriggerData.limit)
            setValue("dayOfMonth", updateTriggerData.dayOfMonth)
            setFormValues(updateTriggerData.exceptions)
        }
    }, [updateTriggerData]);


    const handleSubmitForm = (data, e) => {
        e.preventDefault()
        if (data.weekDays) {
            data.weekDays = {
                mon: data.weekDays.mon ? true : false,
                tue: data.weekDays.tue ? true : false,
                wed: data.weekDays.wed ? true : false,
                thu: data.weekDays.thu ? true : false,
                fri: data.weekDays.fri ? true : false,
                sat: data.weekDays.sat ? true : false,
                sun: data.weekDays.sun ? true : false
            }
        }

        data.exceptions = formValues

        if (checkIsUpdateForm) {
            delete data.arguments
            delete data.methodName
            dispatch(updateTrigger({installationId: installationId, triggerItemId, data}))
        } else {
            if (data.arguments) data.arguments = JSON.parse("[" + data.arguments + "]");
            else data.arguments = [];
            dispatch(createNewTrigger({installationId: installationId, data}))
        }
    }

    const handleCloseModal = () => {
        dispatch(hideModalTrigger())
        reset(defaultValues)
        setFormValues([])
    }

    const assembleSelects = async () => {
        let results = await api.get("/api/devicetypes")

        const commandProducers = []
        results.data.map((device) => {
            commandProducers.push(...device.commandProducers)
        })

        const uniqCommandProducers = [...new Set(commandProducers)];
        setCommandProducersOptions(uniqCommandProducers?.map((item, index) => {
            return (<Option key={index} value={item}>{item}</Option>)
        }))
    }

    const addFormFields = (e) => {
        e.preventDefault()
        setFormValues([...formValues, {date: watchDate, repeat: watchRepeat}])
    }

    const removeFormFields = (key) => {
        let newFormValues = [...formValues];
        newFormValues.splice(key, 1);
        setFormValues(newFormValues)
    }

    const generateFields = (item, key) => {
        return (
            <>
                <div className={"row pb-3"} key={key}>
                    <div className={"col-5"}>
                        <div className="form-group mt-3">
                            <div><label className="mb-2 form-label" htmlFor="repeat">Ponavljanje</label>
                            </div>
                            <input type={"checkbox"}
                                   disabled={checkIsUpdateForm ? true : false}
                                   className={"form-check-input mr-5"}
                                   name={"repeat"}
                                   checked={item.repeat}/>
                        </div>
                    </div>
                    <div className={"col-5"}>
                        <label className="mb-2 form-label" htmlFor="date">Datum</label>
                        <input type="date"
                               disabled={checkIsUpdateForm ? true : false}
                               className="form-control"
                               name={"date"}
                               value={item.date}/>
                    </div>
                    <div className={"col-2 position-relative generate-button"}>
                        <button type="button" className={"btn remove-field position-absolute top-50 start-50 translate-middle"}
                                onClick={() => removeFormFields(key)}>X
                        </button>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <Modal
                show={modalStatus}
                onHide={handleCloseModal}
                backdrop="static"
                keyboard={false}
                size={"lg"}
                className={"modal-trigger"}
            >
                <Modal.Header closeButton className={"modal-header-component"}>
                    <Modal.Title>{"Okidači"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className={"container"}>
                            <div className={"row pb-3"}>
                                <div className={"col-12"}>
                                    <label className="mb-2 form-label" htmlFor="name">Ime</label>
                                    <input type="text"
                                           className="form-control"
                                           name={"name"}
                                           {...register("name")}/>
                                </div>
                            </div>
                            <button className={"btn btn-modal-confirm"} onClick={(e) => addFormFields(e)}>Dodaj
                                ponavljanje
                                i datum
                            </button>
                            <div className={"row pb-3"}>
                                <div className={"col-6"}>
                                    <div className="form-group mt-3">
                                        <div><label className="mb-2 form-label" htmlFor="repeat">Ponavljanje</label>
                                        </div>
                                        <input type={"checkbox"}
                                               className={"form-check-input mr-5"}
                                               name={"repeat"}
                                               {...register("repeat")}/>
                                    </div>
                                </div>
                                <div className={"col-6"}>
                                    <label className="mb-2 form-label" htmlFor="date">Datum</label>
                                    <input type="date"
                                           className="form-control"
                                           name={"date"}
                                           {...register("date")}/>
                                </div>
                            </div>
                            <hr/>
                            {formValues.map((item, key) => generateFields(item, key))}
                            <div className={"row pb-3"}>
                                <div className={"col-12 form-modal-select"}>
                                    <label className="mb-2 form-label" htmlFor="type">Vrsta trigera</label>
                                    <Controller
                                        control={control}
                                        name={"type"}
                                        render={({
                                                     field: {onChange, value, ref},
                                                 }) => (<Select
                                            onChange={onChange}
                                            value={value}
                                            ref={ref}
                                            defaultValue={null}
                                            className={"form-select"}
                                            getPopupContainer={node => node.parentNode}
                                        >
                                            {triggerTypeOptions}
                                        </Select>)}
                                    />
                                </div>
                            </div>
                            {triggerTypeSelect === "MONTHLY" ? (
                                <div className={"row pb-3"}>
                                    <div className={"col-12 form-modal-select"}>
                                        <label className="mb-2 form-label" htmlFor="dayOfMonth">Dan u mjesecu</label>
                                        <Controller
                                            control={control}
                                            name={"dayOfMonth"}
                                            render={({
                                                         field: {onChange, value, ref},
                                                     }) => (<Select
                                                onChange={onChange}
                                                value={value}
                                                ref={ref}
                                                defaultValue={"1"}
                                                className={"form-select"}
                                                getPopupContainer={node => node.parentNode}
                                            >
                                                {triggerDayOfMonth}
                                            </Select>)}
                                        />
                                    </div>
                                </div>
                            ) : ""}
                            {triggerTypeSelect === "WEEKLY" ? (
                                <div className={"row pb-3"}>
                                    <div className="form-group mt-3">
                                        <div><label className="mb-2 form-label" htmlFor="weekDays">Dani u
                                            sedmici</label>
                                        </div>
                                        P: <input type={"checkbox"} className={"form-check-input mr-5"}
                                                  name={"mon"} {...register("weekDays.mon")}/>
                                        U: <input type={"checkbox"} className={"form-check-input mr-5"}
                                                  name={"tue"} {...register("weekDays.tue")}/>
                                        S: <input type={"checkbox"} className={"form-check-input mr-5"}
                                                  name={"wed"} {...register("weekDays.wed")}/>
                                        Č: <input type={"checkbox"} className={"form-check-input mr-5"}
                                                  name={"thu"} {...register("weekDays.thu")}/>
                                        P: <input type={"checkbox"} className={"form-check-input mr-5"}
                                                  name={"fri"} {...register("weekDays.fri")}/>
                                        S: <input type={"checkbox"} className={"form-check-input mr-5"}
                                                  name={"sat"} {...register("weekDays.sat")}/>
                                        N: <input type={"checkbox"} className={"form-check-input"}
                                                  name={"sun"} {...register("weekDays.sun")}/>
                                    </div>
                                </div>
                            ) : ""}
                            {triggerTypeSelect === "EVERY" ? (
                                <div className={"row pb-3"}>
                                    <div className={"col-12 col-12"}>
                                        <label className="mb-2 form-label" htmlFor="minutes">Period [minuta]</label>
                                        <input type="number"
                                               className="form-control"
                                               name={"minutes"}
                                               {...register("minutes")}/>
                                    </div>
                                </div>
                            ) : ""}
                            {triggerTypeSelect === "AT" || triggerTypeSelect === "WEEKLY" || triggerTypeSelect === "MONTHLY" ? (
                                <div className={"row pb-3"}>
                                    <div className={"col-12"}>
                                        <label className="mb-2 form-label" htmlFor="time">Vrijeme</label>
                                        <input type="time"
                                               className="form-control"
                                               name={"time"}
                                               {...register("time")}/>
                                    </div>
                                </div>) : ""}
                            {triggerTypeSelect !== "SUN" ? (
                                <>
                                    <div className={"row pb-3"}>
                                        <div className={"col-12 form-modal-select"}>
                                            <label className="mb-2 form-label" htmlFor="limit">Ograničenja</label>
                                            <Controller
                                                control={control}
                                                name={"limit"}
                                                render={({
                                                             field: {onChange, value, ref},
                                                         }) => (<Select
                                                    onChange={onChange}
                                                    allowClear
                                                    value={value}
                                                    ref={ref}
                                                    className={"form-select"}
                                                    getPopupContainer={node => node.parentNode}
                                                >
                                                    {limitedToOptions}
                                                </Select>)}
                                            />
                                        </div>
                                    </div>
                                    <div className={"row pb-3"}>
                                        <div className={"col-12"}>
                                            <label className="mb-2 form-label" htmlFor="margin">Margina [minuta]</label>
                                            <input type="number"
                                                   className="form-control"
                                                   name={"margin"}
                                                   {...register("margin")}/>
                                        </div>
                                    </div>
                                </>
                            ) : ""}
                            {triggerTypeSelect === "SUN" ? (
                                <>
                                    <div className={"row pb-3"}>
                                        <div className={"col-12 form-modal-select"}>
                                            <label className="mb-2 form-label" htmlFor="sunPosition">Doba dana</label>
                                            <Controller
                                                control={control}
                                                name={"sunPosition"}
                                                render={({
                                                             field: {onChange, value, ref},
                                                         }) => (<Select
                                                    onChange={onChange}
                                                    value={value}
                                                    ref={ref}
                                                    className={"form-select"}
                                                    getPopupContainer={node => node.parentNode}
                                                >
                                                    {sunPositionOptions}
                                                </Select>)}
                                            />
                                        </div>
                                    </div>
                                    <div className={"row pb-3"}>
                                        <div className={"col-12 form-modal-select"}>
                                            <label className="mb-2 form-label" htmlFor="twilight">Sumrak</label>
                                            <Controller
                                                control={control}
                                                name={"twilight"}
                                                render={({
                                                             field: {onChange, value, ref},
                                                         }) => (<Select
                                                    onChange={onChange}
                                                    value={value}
                                                    ref={ref}
                                                    className={"form-select"}
                                                    getPopupContainer={node => node.parentNode}
                                                >
                                                    {twilightTypeOptions}
                                                </Select>)}
                                            />
                                        </div>
                                    </div>
                                    <div className={"row pb-3"}>
                                        <div className={"col-12"}>
                                            <label className="mb-2 form-label" htmlFor="offset">Offset
                                                [minutes]:</label>
                                            <input type="number"
                                                   className="form-control"
                                                   name={"offset"}
                                                   {...register("offset")}/>
                                        </div>
                                    </div>
                                </>
                            ) : ""}
                            {!checkIsUpdateForm ? (<>
                                <div className={"row pb-3"}>
                                    <div className={"col-12 form-modal-select"}>
                                        <label className="mb-2 form-label" htmlFor="methodName">Ime metode</label>
                                        <Controller
                                            control={control}
                                            name={"methodName"}
                                            render={({
                                                         field: {onChange, value, ref},
                                                     }) => (<Select
                                                onChange={onChange}
                                                value={value}
                                                ref={ref}
                                                className={"form-select"}
                                                getPopupContainer={node => node.parentNode}
                                            >
                                                {commandProducersOptions}
                                            </Select>)}
                                        />
                                    </div>
                                </div>
                                <div className={"row pb-3"}>
                                    <div className={"col-12"}>
                                        <label className="mb-2 form-label" htmlFor="arguments">Argumenti</label>
                                        <input type="text"
                                               className="form-control"
                                               name={["arguments"]}
                                               {...register("arguments")}/>
                                    </div>
                                </div>
                            </>) : ""}
                        </div>
                    </form>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <div className={"modal-footer-component"}>
                                <button className={"btn btn-modal-cancel"} onClick={() => dispatch(handleCloseModal())}>
                                    {"Otkaži"}
                                </button>
                                <button
                                    className={"btn btn-modal-confirm"}
                                    onClick={handleSubmit(handleSubmitForm)}>{checkIsUpdateForm ? "Ažuriraj" : "Kreiraj"}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default TriggerModal;
